// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// export const exportToPDF = async (
//   elementId: string,
//   filename: string = 'crossword.pdf'
// ) => {
//   try {
//     const element = document.getElementById(elementId);
//     if (!element) {
//       throw new Error('Element not found');
//     }
//     // Clone the element to ensure proper styling before capture
//     const clonedElement = element.cloneNode(true) as HTMLElement;
//     // Get all input elements and ensure they have proper styling
//     const inputs = clonedElement.querySelectorAll('input');
//     inputs.forEach((input) => {
//       // Ensure uppercase text
//       if (input.value) {
//         input.value = input.value.toUpperCase();
//         // input.setAttribute('value', input.value.toUpperCase());
//       }
//       // Apply explicit styling to ensure proper rendering
//       input.style.textTransform = 'uppercase';
//       input.style.textAlign = 'center';
//       input.style.fontSize = '1.2rem';
//       input.style.fontWeight = 'bold';
//       input.style.height = '40px';
//       input.style.width = '40px';
//       input.style.lineHeight = 'normal';
//       input.style.padding = '0';
//       input.style.margin = '0';
//       input.style.border = '1px solid #7400a0';
//       input.style.boxSizing = 'border-box';
//       input.style.verticalAlign = 'middle';
//       // Remove any default input styling that might interfere
//       input.style.outline = 'none';
//       input.style.borderRadius = '0';
//     });
//     // Hide control buttons for PDF export
//     const controlButtons = clonedElement.querySelector('.app-controls');
//     if (controlButtons) {
//       (controlButtons as HTMLElement).style.display = 'none';
//     }
//     // Temporarily add the cloned element to the DOM for html2canvas
//     clonedElement.style.position = 'absolute';
//     clonedElement.style.left = '-9999px';
//     clonedElement.style.top = '-9999px';
//     document.body.appendChild(clonedElement);
//     // Create canvas from the cloned element
//     const canvas = await html2canvas(clonedElement, {
//       scale: 2, // Higher scale for better quality
//       useCORS: true,
//       allowTaint: true,
//       backgroundColor: '#ffffff',
//     });
//     // Remove the cloned element from DOM
//     document.body.removeChild(clonedElement);
//     const imgData = canvas.toDataURL('image/png');
//     // Determine orientation based on crossword dimensions
//     const imgWidth = canvas.width;
//     const imgHeight = canvas.height;
//     const isLandscape = imgWidth > imgHeight;
//     const pdf = new jsPDF({
//       orientation: isLandscape ? 'landscape' : 'portrait',
//       unit: 'mm',
//       format: 'a4',
//     });
//     // Add title
//     pdf.setFontSize(16);
//     pdf.setFont('helvetica', 'bold');
//     pdf.text('Crossword Puzzle', pdf.internal.pageSize.getWidth() / 2, 15, {
//       align: 'center',
//     });
//     pdf.setFontSize(10);
//     pdf.setFont('helvetica', 'normal');
//     pdf.text(
//       new Date().toLocaleDateString(),
//       pdf.internal.pageSize.getWidth() / 2,
//       25,
//       { align: 'center' }
//     );
//     // Define margins (in mm) - leave space for title
//     const margin = 10;
//     const topMargin = 35; // Extra space for title
//     // Calculate available space after margins
//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = pdf.internal.pageSize.getHeight();
//     const availableWidth = pdfWidth - 2 * margin;
//     const availableHeight = pdfHeight - topMargin - margin;
//     // Calculate scaling to fit the available space while maintaining aspect ratio
//     const ratio = Math.min(
//       availableWidth / (imgWidth / 2), // Divide by 2 because canvas scale is 2
//       availableHeight / (imgHeight / 2)
//     );
//     const scaledWidth = (imgWidth / 2) * ratio;
//     const scaledHeight = (imgHeight / 2) * ratio;
//     // Center the image within the available space (accounting for margins)
//     const x = margin + (availableWidth - scaledWidth) / 2;
//     const y = topMargin + (availableHeight - scaledHeight) / 2;
//     pdf.addImage(imgData, 'PNG', x, y, scaledWidth, scaledHeight);
//     pdf.save(filename);
//   } catch (error) {
//     console.error('Error generating PDF:', error);
//     alert('Error generating PDF. Please try again.');
//   }
// };
export const printCrossword = (elementId, length, height, crosswordName, identifier) => {
    try {
        const element = document.getElementById(elementId);
        if (!element) {
            throw new Error('Element not found');
        }
        // Clone the element to preserve input values and styles
        const clonedElement = element.cloneNode(true);
        // Get all input elements in the original and cloned elements
        const originalInputs = element.querySelectorAll('input');
        const clonedInputs = clonedElement.querySelectorAll('input');
        // Copy values and styles from original inputs to cloned inputs
        originalInputs.forEach((originalInput, index) => {
            const clonedInput = clonedInputs[index];
            if (clonedInput) {
                // Copy the value
                clonedInput.value = originalInput.value;
                clonedInput.setAttribute('value', originalInput.value);
                // Copy the computed styles (especially color and font-weight)
                // const computedStyle = window.getComputedStyle(originalInput);
                // clonedInput.style.color = computedStyle.color;
                // clonedInput.style.fontWeight = computedStyle.fontWeight;
                // clonedInput.style.backgroundColor = computedStyle.backgroundColor;
                // Make the input read-only for printing
                clonedInput.readOnly = true;
            }
        });
        let unit = 40, pageWidth, pageHeight, orientation;
        // Standard A4 page dimensions in pixels (assuming 96 DPI)
        // A4: 210mm x 297mm = ~794px x 1123px at 96 DPI
        // Account for margins and header space
        if (length < height) {
            pageWidth = 170;
            pageHeight = 232;
            orientation = 'portrait';
        }
        else {
            pageWidth = 257;
            pageHeight = 170;
            orientation = 'landscape';
        }
        // Use the smaller scale to ensure it fits in both dimensions
        unit = Math.floor(Math.min(pageWidth / length, pageHeight / height));
        // Create a new window for printing
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            throw new Error('Unable to open print window');
        }
        // Get the current page styles
        const styles = Array.from(document.styleSheets)
            .map((styleSheet) => {
            try {
                return Array.from(styleSheet.cssRules)
                    .map((rule) => rule.cssText)
                    .join('\n');
            }
            catch (e) {
                // Handle cross-origin stylesheets
                return '';
            }
        })
            .join('\n');
        // Create the print document
        printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Crossword - ${crosswordName}</title>
          <style>
            ${styles}
            @media print {
              @page {
                margin: 20mm;
                size: A4 ${orientation};
              }
              * {
                box-sizing: border-box;
              }
              body { 
                margin: 0; 
                padding: 0;
                background: white !important;
                font-family: Arial, sans-serif;
                width: 100vw;
                height: 100vh;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
              }
              .no-print { display: none !important; }
              #crossword-grid {
                width: 100% !important;
                height: 100% !important;
                display: flex !important;
                flex-direction: column !important;
                align-items: center !important;
                padding: 5px !important;
              }
              #crossword-grid > div {
                display: flex !important;
                flex-direction: row !important;
                margin: 0 !important;
                padding: 0 !important;
              }

              .crossword-cell-empty {
                width: ${unit}mm !important;
                height: ${unit}mm !important;
              }

              .crossword-cell-filled {
                background-color: defaults.$colour-gyaan;
                width: ${unit}mm !important;
                height: ${unit}mm !important;
              }

              .crossword-cell-input {
                width: ${unit}mm !important;
                height: ${unit}mm !important;
              }
              input {
                border: none;
                // outline: 1px solid #7400a0 !important;
                background: white !important;
                text-align: center !important;
                font-size: ${unit / 2}mm !important;
                width: ${unit}mm !important;
                height: ${unit}mm !important;
                margin: 0 !important;
                padding: 0 !important;
                text-transform: uppercase !important;
                font-weight: bold !important;
                /* Preserve colors for different states */
                -webkit-print-color-adjust: exact !important;
                color-adjust: exact !important;
                print-color-adjust: exact !important;
              }
              fieldset {
                border: none !important;
                margin: 0 !important;
                padding: 0 !important;
                position: relative !important;
                height: 100%;
                width: 100%;
              }
              legend {
                position: absolute !important;
                font-size: ${unit / 4}mm !important;
                top: 1mm !important;
                left: 0.5mm !important;
                line-height: 1 !important;
                margin: 0 !important;
                padding: 0 !important;
                color: black !important;
                font-weight: bold !important;
                z-index: 1 !important;
              }
              /* Hide any blank divs that might cause spacing issues */
              div[style*="background-color"] {
                width: ${unit}mm !important;
                height: ${unit}mm !important;
              }
            }
            @media screen {
              body {
                padding: 5px;
              }
            }
          </style>
        </head>
        <body>
          <div style="text-align: center; margin:0">
            <p style="margin:0; font-size: 12px;">${identifier}</p>
          </div>
          ${clonedElement.outerHTML}
        </body>
      </html>
    `);
        printWindow.document.close();
        // Wait for content to load then print
        printWindow.onload = () => {
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 300); // Small delay to ensure everything is rendered
        };
    }
    catch (error) {
        console.error('Error printing:', error);
        alert('Error printing. Please try again.');
    }
};
